import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { DeepPartial, Schema } from '~~/common/types/api';

type ProductVariantModel = DeepPartial<Schema<'ProductVariantModel'>> & {
  details: unknown[];
};

interface CompareItem {
  id: number;
  selectedVariant: ProductVariantModel;

  [key: string]: unknown;
}

interface SetProductDetailsPayload {
  index: number;
  result: unknown;
}

const VARIANT_PROP = 'selectedVariant';
export const useCompareStore = defineStore('compare', () => {
  const compareItems = ref<CompareItem[]>([]);
  const compareItemIndex = ref(0);
  const maxCompareCount = ref(4);
  const isComparePage = ref(false);

  function pushNewCompareItem (compareItem: CompareItem) {
    if (compareItems.value.length <= maxCompareCount.value) {
      if (!compareItems.value.find(item => item.id === compareItem.id)) {
        // reset details array
        compareItem.selectedVariant.details = [];
        compareItems.value[compareItems.value.length] = compareItem;
      }
    }
  }

  function removeCompareItem (index: number) {
    compareItems.value.splice(index, 1);
  }

  function removeAllCompareItems () {
    compareItems.value = [];
  }

  function setIsComparePage (payload: boolean) {
    isComparePage.value = payload;
  }

  function setProductDetails (payload: SetProductDetailsPayload) {
    const item = compareItems.value[payload.index];
    if (item?.[VARIANT_PROP].details) {
      item[VARIANT_PROP].details.push(payload.result);
    }
  }

  function changeCompareItemIndex (payload: number) {
    compareItemIndex.value = payload;
  }

  return {
    compareItems,
    compareItemIndex,
    maxCompareCount,
    isComparePage,
    pushNewCompareItem,
    removeCompareItem,
    removeAllCompareItems,
    setIsComparePage,
    setProductDetails,
    changeCompareItemIndex,
  };
});
